/**
 * base64からblobに変換
 * @param {string} base64Data base64データ
 * @param {string} contentType コンテンツタイプ
 * @return {Blob} blobデータ
 */
const base64toBlob = (base64Data: string, contentType: string): Blob => {
  const TYPE = contentType || '';
  const SLICESIZE = 1024;
  const BYTECHARACTERS = atob(base64Data);
  const BYTESLENGTH = BYTECHARACTERS.length;
  const SLICESCOUNT = Math.ceil(BYTESLENGTH / SLICESIZE);
  const BYTEARRAYS = new Array(SLICESCOUNT);
  for (let sliceIndex = 0; sliceIndex < SLICESCOUNT; sliceIndex += 1) {
    const BEGIN = sliceIndex * SLICESIZE;
    const END = Math.min(BEGIN + SLICESIZE, BYTESLENGTH);

    const BYTES = new Array(END - BEGIN);
    for (let offset = BEGIN, i = 0; offset < END; i += 1, offset += 1) {
      BYTES[i] = BYTECHARACTERS[offset].charCodeAt(0);
    }
    BYTEARRAYS[sliceIndex] = new Uint8Array(BYTES);
  }
  return new Blob(BYTEARRAYS, { type: TYPE });
};

/**
 * ファイル存在チェック
 * @param {File} file ファイル
 * @return チェック結果 存在する場合：true 存在しない場合:false
 */
export const isFileExist = async (file :File) :Promise<boolean> => {
    if(file.size === 0){
      // 0Byteファイルはエラー
      return false;
    }
    // ファイルの中身を参照
    const hasError = await file
      .slice(0, 1)
      .text()
      .then(() => false)
      .catch(() => true);

    if (!hasError) {
      return true;
    }
    return false;
}

/**
 * 複数ファイル存在チェック
 * @param {File[]} files ファイルリスト
 * @return チェック結果 すべてのファイルが存在する場合：true 1つでもファイルが存在しない場合:false
 */
export const isFilesExist = async (files :File[]) :Promise<boolean> => {

  let errCount = 0;

  await Promise.all(Object.entries(files).map(async item => {
    // ファイル存在チェック
    await isFileExist(item[1]).then((result) => {
      // 存在しない場合
      if (!result) {
        errCount += 1;
      }
    });
  }))

  // ファイルがすべて存在する場合
  if(errCount === 0){
    return true;
  }
  // 1件でもファイルが存在しない場合
  return false;
}

export default base64toBlob;
